<template>
	<!-- Navbar start -->
	<nav ref="nav" :class="navClass">
		<!-- Logo start -->
		<div class="h-full flex flex-col justify-center">
			<a href="#home" @click="closeMenu">
				<img :src="logoSrc" alt="Dark Pollen" class="w-3/4 pt-4 pb-4 transition duration-300">
			</a>
		</div>
		<!-- Logo end -->

		<!-- Toggler start -->
		<button
			type="button"
			role="menubar"
			class="md:hidden"
			:aria-expanded="isMenuOpen"
			aria-controls="mobile-nav-menu"
			@click="navToggle"
		>
			<i :class="menuIconClass"></i>
		</button>
		<!-- Toggler end -->

		<!-- Menu content start -->
		<div
			id="mobile-nav-menu"
			:class="menuClass"
			role="menu"
			:aria-expanded="isMenuOpen"
		>
			<!-- Links start -->
			<a href="#about-section" role="menuitem" @click="closeMenu">
				<p :class="linkClass">About</p>
			</a>

			<a href="#services-section" role="menuitem" @click="closeMenu">
				<p :class="linkClass">Locations</p>
			</a>

			<a href="#portfolio-section" role="menuitem" @click="closeMenu">
				<p :class="linkClass">Gallery</p>
			</a>

			<a href="#contact-section" :class="buttonClass" role="menuitem" @click="closeMenu">
				Contact us
			</a>
			<!-- Links end -->
		</div>
		<!-- Menu content end -->
	</nav>
	<!-- Navbar end -->
</template>

<script>
import logoLong from '@/assets/logo-long.png'

export default {
	data() {
		return {
			isMenuOpen: false,
			isDesktop: window.innerWidth >= 1024,
			isScrolled: false,
			isVisible: false,
			logoLong
		}
	},
	computed: {
		navClass() {
			return [
				'w-screen fixed top-0 left-0 p-4 lg:px-20 flex justify-between z-50 transition-all duration-300',
				this.isVisible ? 'translate-y-0' : '-translate-y-full',
				this.isScrolled
					? 'bg-lime-300/95 shadow-lg backdrop-blur-sm'
					: 'bg-lime-100/78 backdrop-blur-md border-b border-white/40'
			]
		},
		menuClass() {
			return [
				'absolute left-0 right-0 top-full md:top-auto flex-col gap-6 items-center p-8 md:p-4 md:flex-row transition-all duration-300',
				this.isMenuOpen ? 'flex' : 'hidden',
				this.isScrolled
					? 'bg-lime-300/95 backdrop-blur-sm shadow-lg border-t border-purple/30 md:bg-transparent md:border-none md:shadow-none'
					: 'bg-lime-100/95 backdrop-blur-md shadow-lg border-t border-white/40 md:bg-transparent md:border-none md:shadow-none',
				'md:static md:flex'
			]
		},
		linkClass() {
			return [
				'mx-4 font-semibold transition-colors',
				'text-secondary hover:text-pink'
			]
		},
		buttonClass() {
			return this.isScrolled
				? 'bg-purple hover:bg-purple-600 text-white font-bold py-2 px-4 rounded-full transition-colors'
				: 'bg-purple text-white hover:bg-pink font-bold py-2 px-4 rounded-full transition-colors'
		},
		menuIconClass() {
			return [
				'fa-solid fa-bars text-2xl transition-colors',
				'text-secondary'
			]
		},
		logoSrc() {
			return this.logoLong
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll)
		window.addEventListener('resize', this.handleResize)
		document.addEventListener('click', this.handleClickOutside)
		this.handleScroll()
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll)
		window.removeEventListener('resize', this.handleResize)
		document.removeEventListener('click', this.handleClickOutside)
	},
	methods: {
		handleResize() {
			this.isDesktop = window.innerWidth >= 1024
			if (this.isDesktop) {
				this.closeMenu()
			}
			this.handleScroll()
		},
		handleScroll() {
			this.isScrolled = window.scrollY > 24
			const aboutSection = document.querySelector('#about-section')
			if (!aboutSection) {
				this.isVisible = this.isScrolled
				return
			}

			const aboutSectionTop = aboutSection.getBoundingClientRect().top
			this.isVisible = aboutSectionTop <= 120

			if (!this.isVisible) {
				this.closeMenu()
			}
		},
		handleClickOutside(event) {
			if (!this.isMenuOpen) return
			if (this.$refs.nav && !this.$refs.nav.contains(event.target)) {
				this.closeMenu()
			}
		},
		navToggle() {
			this.isMenuOpen = !this.isMenuOpen
		},
		closeMenu() {
			this.isMenuOpen = false
		}
	}
}
</script>
